//  Polyfill Number.isInteger
//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

import debug from "debug";

const MODULE_NAME = 'app.polyfills/number-is-integer';
const log = debug(MODULE_NAME);


export default function() {
    !Number.isInteger && log('Number.isInteger to be polyfilled');
    Number.isInteger =
        Number.isInteger ||
        function(value) {
            return (
                typeof value === 'number' &&
                isFinite(value) &&
                Math.floor(value) === value
            );
        };
}



// WEBPACK FOOTER //
// ./client/src/core/polyfills/number-is-integer.js